'use strict';

var _ = require('lodash');
var encode = require('hashcode').hashCode;
var InterlineFaresAdjustmentTransformerFactory = function InterlineFaresAdjustmentTransformerFactory(DataTransformer) {
  var partnerHashKey = ['partnerSegment', 'partnerAirline', 'trueOD', 'classNames'];
  function InterlineFaresAdjustmentTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'interline-fares-adjustment-mode';
    this.priority = 1;
  }
  InterlineFaresAdjustmentTransformer.prototype = Object.create(DataTransformer.prototype);
  InterlineFaresAdjustmentTransformer.constructor = InterlineFaresAdjustmentTransformer;
  InterlineFaresAdjustmentTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  InterlineFaresAdjustmentTransformer.prototype.isCacheable = function () {
    return false;
  };
  InterlineFaresAdjustmentTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  InterlineFaresAdjustmentTransformer.prototype.transform = function (domainData) {
    // Get Domain Data
    var partnerAdjustments = _.get(domainData, 'domain.results', []);
    return _.chain(partnerAdjustments).map(function (partnerAdjustment) {
      // Add Hash to verify possible duplication.
      partnerAdjustment.hash = encode().value(_.pick(partnerAdjustment, partnerHashKey));

      // Need it for check if classes duplicated
      partnerAdjustment.groupKey = [partnerAdjustment.partnerSegment, partnerAdjustment.partnerAirline, partnerAdjustment.trueOD].join(':');
      return partnerAdjustment;
    }).value();
  };
  return InterlineFaresAdjustmentTransformer;
};
InterlineFaresAdjustmentTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = InterlineFaresAdjustmentTransformerFactory;